import { useEffect, useState } from "react";

interface BenefitThumbnailProps {
  url?: string | null;
  alt: string;
  size?: number;
}

/**
 * Miniatura de beneficio para tablas. Si no hay imagen, o la URL falla al
 * cargar, muestra el ícono de reemplazo en vez de dejar el texto alternativo
 * desbordando el cuadro.
 */
export const BenefitThumbnail = ({ url, alt, size = 56 }: BenefitThumbnailProps) => {
  const [failed, setFailed] = useState(false);

  useEffect(() => setFailed(false), [url]);

  if (url && !failed) {
    return (
      <img
        src={url}
        alt={alt}
        onError={() => setFailed(true)}
        style={{
          width: size,
          height: size,
          objectFit: "cover",
          borderRadius: 8,
          display: "block",
        }}
      />
    );
  }

  return (
    <div
      className="flex align-items-center justify-content-center surface-200"
      style={{ width: size, height: size, borderRadius: 8 }}
      role="img"
      aria-label={alt}
    >
      <i className="pi pi-image text-500 text-xl" />
    </div>
  );
};
